"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsIconSelector = exports.IlIconSelectorDefault = void 0;
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_icon_selector_1 = require("./il-icon-selector");
exports.IlIconSelectorDefault = {
    component: material_1.ButtonGroup,
    options: [
        enums_1.IconEnum.CALENDAR_STAR,
        enums_1.IconEnum.TROPHY,
        enums_1.IconEnum.CAKE_CANDLES,
        enums_1.IconEnum.BRIEFCASE_MEDICAL,
        enums_1.IconEnum.BUILDING_COLUMNS,
        enums_1.IconEnum.VAN_SHUTTLE,
        enums_1.IconEnum.UMBRELLA_BEACH,
        enums_1.IconEnum.FAMILY,
        enums_1.IconEnum.LEAF,
        enums_1.IconEnum.PERSON_SWIMMING,
        enums_1.IconEnum.PERSON_RUNNING,
        enums_1.IconEnum.FACE_THERMOMETER,
        enums_1.IconEnum.STAR_SHARP_SOLID,
        enums_1.IconEnum.SUN_SOLID,
        enums_1.IconEnum.SNOWFLAKE_SOLID,
        enums_1.IconEnum.PARTY_HORN_SOLID,
    ],
    onSelect: console.log,
};
exports.EventsIconSelector = (0, get_component_1.getComponent)(il_icon_selector_1.ILIconSelector, exports.IlIconSelectorDefault);
